import React, { useState, forwardRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Sheet from '@mui/joy/Sheet';
import Stack from '@mui/joy/Stack';
import { styled } from '@mui/joy/styles';

import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import Input from '@mui/joy/Input';
import Link from "@mui/material/Link";
import Button from '@mui/joy/Button';


import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


import EmailIcon from '../../assets/icons/EmailIcon.svg'
import PasswrodIcon from '../../assets/icons/passwordIcon.svg'
import BackIcon from '../../assets/icons/backIcon.svg'

///////////////////////////// API
import { sendResetCode } from '../../Api/ForgetPassword';

//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



const schema = yup.object({
    email: yup.string().required("البريد الالكتروني مطلوب")
})

export default function ForgetPasswordEmail() {
    const navigate = useNavigate()

    const [loadingApi, setLoadingApi] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            email: ""
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    }

    const sendEmail = async (data) => {
        setLoadingApi(true)
        try {
            const res = await sendResetCode(data)
            if (res) {
                setLoadingApi(false)
                setMessageAlert('تم ارسال كود التعين بنجاح')
                setOpenAlert(true)
                navigate('/congratulations')
            }
        } catch (error) {
            console.log(error.response)
            if (error.response) {
                setLoadingApi(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    }

    return (
        <>
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="warning">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>
            <Box sx={{
                width: '80%',
                backgroundColor: '#FFF',
                borderRadius: '30px',
                border: '1px solid #60A5DC',
                margin: 'auto',
                marginTop: '40px',
                padding: '70px 0'
            }}
            >
                <Link href="/" variant="body2"
                    sx={{
                        textAlign: 'end',
                        textDecoration: 'none',
                        padding: '0 10%'
                    }}>
                    <img src={BackIcon} alt='back icon' />
                </Link>

                <Typography level="h3" sx={{ padding: '0 10%', color: '#231F20', fontSize: '30px', marginBottom: '30px' }}>هل نسيت كلمة المرور ؟</Typography>
                <Typography level="p" sx={{ padding: '0 10%', color: '#434448', fontSize: '16px' }}>أدخل عنوان البريد الإلكتروني الخاص بك وسوف تتلقى رابط لإعادة تعيين كلمة المرور الخاصة بك</Typography>
                <form onSubmit={handleSubmit(sendEmail)}>
                    <Stack spacing={5} sx={{ width: '80%', margin: 'auto', marginTop: '50px' }}>
                        <FormControl>
                            <FormLabel sx={{ fontSize: '16px', color: '#434448', fontWeight: 'bold' }}>البريد الالكتروني</FormLabel>
                            <Input
                                type='email'
                                placeholder="ادخل البريد الالكتروني"
                                startDecorator={<img src={EmailIcon}
                                    alt='email icon' />}
                                sx={{ height: '60px', borderRadius: '30px' }}
                                {...register('email')}
                            />
                            {errors.email &&
                                <Typography
                                    color="danger"
                                    level="body-xs"
                                    variant="plain"
                                >{errors.email?.message}</Typography>
                            }
                        </FormControl>

                        <Button
                            type='submit'
                            loading={loadingApi}
                            sx={{ height: '60px', backgroundColor: '#3E64F4', color: '#FFF', fontSize: '20px', borderRadius: '30px' }}
                        >إرسال كود تعيين كلمة السر</Button>
                    </Stack>
                </form>
            </Box>
        </>
    )
}